import { lazy } from 'react';

export { Tenders } from './tenders';

export const LazyTenders = lazy(() => import('./tenders').then((mod) => ({ default: mod.Tenders })));
